export default __webpack_public_path__ + "static/media/logo-white.0d9c5a3f.png";